import DapDSTimeline from './timeline.component'

export * from './timeline.component'
export default DapDSTimeline

DapDSTimeline.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-timeline': DapDSTimeline
  }
}
